module.exports = __webpack_public_path__ + "img/藁城宫灯.43e2362d.jpg";